import { Grid } from '@mui/material';
import React from 'react';
import { Survey, TagModel } from '../survey.types';
import { SelectionState } from '../../../pages/motive-manage-surveys';
import SurveyItemDetails from './survey-item-details';
import SurveyItem from './survey-item';

const SurveyFolder: React.FC<Props> = ({
  tag,
  index,
  draggedAnalysisId,
  handleCheckboxClick,
  selectionState,
  deleteTag,
  handleEditTagClick,
  handleOpenConfirmDeleteSurveyDialog,
  handleToggleVisibility,
  dynamicRoute,
  token,
}) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);

  const selectionCount = tag.surveys.reduce((prev: number, curr) => {
    const count = prev + (selectionState[curr.id] ? 1 : 0);
    return count;
  }, 0);

  const handleChange = (event: React.ChangeEvent<any>, isExpanded: boolean) => {
    if (selectionCount === 0) {
      setExpanded(isExpanded);
    }
  };

  return (
    <Grid container={true}>
      <Grid size={12}>
        <SurveyItem
          tagId={tag.tagId}
          tagName={tag.tagName}
          key={'panel' + tag.tagId}
          handleChange={handleChange}
          expanded={expanded}
          index={index}
          selectionCount={selectionCount}
          draggingExist={Boolean(draggedAnalysisId)}
          handleOpenConfirmDeleteSurveyDialog={handleOpenConfirmDeleteSurveyDialog}
          tag={tag}
          deleteTag={deleteTag}
          handleEditTagClick={handleEditTagClick}
          handleToggleVisibility={handleToggleVisibility}
          token={token}
        >
          {expanded &&
            tag.surveys.map((survey: Survey, analysisIndex: number) => (
              <SurveyItemDetails
                isSelected={selectionState[survey.id]}
                isGhosting={selectionState[survey.id] && Boolean(draggedAnalysisId) && draggedAnalysisId !== survey.id}
                survey={survey}
                key={survey.id}
                index={analysisIndex}
                handleCheckboxClick={handleCheckboxClick}
                selectionCount={selectionCount}
                dynamicRoute={dynamicRoute}
                token={token}
              />
            ))}
        </SurveyItem>
      </Grid>
    </Grid>
  );
};

interface Props {
  tag: TagModel;
  index: number;
  draggedAnalysisId: string;
  selectionState: SelectionState;
  dynamicRoute: string;
  token: string;

  handleCheckboxClick(analysisId: string): (event: React.ChangeEvent, checked: boolean) => void;

  deleteTag(tagId: string): void;

  handleEditTagClick(tagId: string): (event: React.SyntheticEvent) => void;

  handleOpenConfirmDeleteSurveyDialog(currentTag: TagModel): () => void;

  handleToggleVisibility(tagId: string, visibility?: boolean): () => void;
}

export default React.memo(SurveyFolder);
